var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"full-height",class:( _obj = {}, _obj[_vm.classForViewRound] = true, _obj[_vm.textColor] = true, _obj ),attrs:{"color":_vm.getColor,"elevation":"3"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }